import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { resources as unlockOperationResources } from '@jira/router-resources__eoc-unlock-operations/src/EocUnlockOperations.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { eocChangeboardingLayout } from '@jira/platform__layouts-eoc-changeboarding-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { unlockOperationsRoute } from '@jira/router-routes__eoc-unlock-operations-routes/src/unlockOperationsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import UnlockOperations, { LazyUnlockOperations } from './ui/index.tsx';

export const unlockOperationsRouteEntry: Route = createEntry(unlockOperationsRoute, () => ({
	group: 'eoc',
	layout: eocChangeboardingLayout,
	// eslint-disable-next-line no-restricted-syntax
	component: UnlockOperations,

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarProductsSettingResource(),
		...unlockOperationResources(),
	],

	navigation: {
		sidebarId: SidebarIdGlobalProductsSettings,
		menuId: MenuIdSettings,
	},

	forPaint: [LazyAtlassianNavigation, LazyUnlockOperations],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
